import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, switchMap } from 'rxjs';
import { environmentConfig } from '../../environment';
import { AuthService } from '../services/auth.service';
import { HttpHeaders } from '@angular/common/http';
import { getAuth } from 'firebase/auth';

@Injectable({
  providedIn: 'root'
})
export class MenuService {
  private apiUrl = environmentConfig.apiBaseUrl;

  constructor(private http: HttpClient, private authService: AuthService) { }

  private fetchAuthenticated(url: string, method: 'GET' | 'POST' | 'PUT', token: any, bodyData?: any,): Observable<any> {
    const auth = getAuth();
    const user = auth.currentUser;

    return new Observable<any>(observer => {
      const headers = new HttpHeaders({
        'Authorization': `Bearer ` + token
      });

      const httpOptions = { headers };
      let httpCall: Observable<any>;

      if (method === 'GET') {
        httpCall = this.http.get(url, httpOptions);
      } else if (method === 'POST') {
        httpCall = this.http.post(url, bodyData, httpOptions);
      } else if (method === 'PUT') {
        httpCall = this.http.put(url, bodyData, httpOptions);
      } else {
        observer.error('Unsupported method');
        return;
      }

      httpCall.subscribe({
        next: data => {
          //console.log('✅ Response:', data);
          observer.next(data);
        },
        error: err => {
          console.error('❌ HTTP Error:', err);
          observer.error(err);
        },
        complete: () => observer.complete()
      });
    });
  }

  getMenuData(token: any): Observable<any> {
    console.log()
    return this.authService.getUserRole().pipe(
      switchMap(role => {
        const url = `${this.apiUrl}/api/getmenuitems?role=${encodeURIComponent(role)}`;
        return this.fetchAuthenticated(url, 'GET', token);
      })
    );
  }

  getWeeklyTodo(token: any): Observable<any> {
    return this.authService.getUserRole().pipe(
      switchMap(() => {
        const userId = Number(sessionStorage.getItem('wOSUserId') || 0);
        const url = `${this.apiUrl}/api/getweeklytodo/${encodeURIComponent(userId)}`;
        return this.fetchAuthenticated(url, 'GET', token);
      })
    );
  }

  getAccountAccess(token: any): Observable<any> {
    const userId = Number(sessionStorage.getItem('wOSUserId') || 0);
    const url = `${this.apiUrl}/api/getaccountaccess?user=` + userId.toString();
    return this.fetchAuthenticated(url, 'GET', token);
  }
}
